import React from "react";
import { NavLink } from "react-router-dom";
import { getCurrentUser } from "../auth";

// Base navigation styles
const navStyle = {
  display: "block",
  padding: "12px 24px",
  color: "#7B3F00",
  textDecoration: "none",
  borderRadius: 6,
  marginBottom: 4,
  fontWeight: 600,
  transition: "background 0.2s"
};

// Helper function for navigation link styles
const getNavLinkStyle = (isActive) => ({
  ...navStyle,
  background: isActive ? "#fffde7" : undefined
});

// Navigation items grouped by section
const navItems = {
  main: [
    { path: "/finance/dashboard", label: "Dashboard", icon: "bi-speedometer2" },
    { path: "/finance/transactions", label: "Collections & Transactions", icon: "bi-receipt" },
    { path: "/finance/cashflow", label: "Daily Cash Flow", icon: "bi-currency-exchange" },
    { path: "/finance/payments", label: "Payments", icon: "bi-wallet2" },
    { path: "/finance/student-fees", label: "Student Fees", icon: "bi-people" },
    { path: "/finance/legacy-balances", label: "Legacy Balances", icon: "bi-archive" },
    { path: "/finance/tuition-ledger", label: "Tuition Fee Ledger", icon: "bi-bank" },
    { path: "/finance/uniforms/inventory", label: "Uniforms (Inventory & Sales)", icon: "bi-bag" },
    { path: "/finance/books/inventory", label: "Books (Consignment)", icon: "bi-book" },
  ],
  reports: [
    { path: "/finance/financial-reports", label: "Financial Reports", icon: "bi-graph-up" },
    { path: "/finance/tuition-calculator", label: "Tuition Calculator", icon: "bi-calculator" }
  ],
  settings: [
    { path: "/finance/settings/chart-of-accounts", label: "Chart of Accounts (Advanced)", icon: "bi-journal-text" }
  ],
  switchSystem: [
    { path: "/sis/dashboard", label: "Student Information System", icon: "bi-mortarboard" },
    { path: "/hr/payroll", label: "HR / Payroll System", icon: "bi-people" },
    { path: "/admin/migrate", label: "Data Migration", icon: "bi-cloud-upload" },
    { path: "/admin/cleanup", label: "Data Cleanup", icon: "bi-trash" },
    { path: "/admin/sections", label: "Grade Sections", icon: "bi-list-check" },
    { path: "/admin/teacher-workloads", label: "Teacher Workloads", icon: "bi-person-workspace" },
    { path: "/admin/recalculate-tuition", label: "Recalculate Tuition", icon: "bi-calculator" },
    { path: "/admin/tuition-pricing", label: "Tuition Pricing", icon: "bi-cash-stack" }
  ]
};

// Component for rendering navigation sections
const NavSection = ({ title, items, showIcons }) => (
  <div style={{ marginBottom: "24px" }}>
    {title && (
      <h4 style={{ 
        color: "#5d4037", 
        fontSize: "14px", 
        fontWeight: 700, 
        textTransform: "uppercase", 
        letterSpacing: "1px", 
        margin: "16px 12px 8px 12px",
        opacity: 0.8
      }}>
        {title}
      </h4>
    )}
    {items.map((item) => (
      <li key={item.path} style={{ listStyle: "none" }}>
        <NavLink 
          to={item.path} 
          style={({ isActive }) => getNavLinkStyle(isActive)}
        >
          {showIcons && item.icon && <i className={`bi ${item.icon} me-2`}></i>}
          {item.label}
        </NavLink>
      </li>
    ))}
  </div>
);

export default function Sidebar() {
  const user = getCurrentUser();
  const role = String(user?.role || "").toLowerCase();
  const roles = Array.isArray(user?.roles) ? user.roles.map(r => String(r).toLowerCase()) : [];
  const isAdmin = role === "admin" || role === "superadmin" || roles.includes("admin") || roles.includes("superadmin");
  return (
    <aside className="sidebar" style={{ background: "#ffb300", minHeight: "100vh", color: "#fff", padding: "24px 0" }}>
      <img
        src="/vmsc_logo.png"
        alt="School Logo"
        style={{ width: 130, height: 130, margin: "0 auto 16px auto", display: "block", borderRadius: "50%" }}
      />
      <h3 style={{ textAlign: "center", fontWeight: 700, marginBottom: 32, letterSpacing: 1, padding: "0 12px" }}>
        Finance System
      </h3>
      <nav>
        <ul style={{ listStyle: "none", padding: "0", margin: 0 }}>
          <NavSection items={navItems.main} showIcons={true} />
          <NavSection title="Reports & Analytics" items={navItems.reports} showIcons={true} />
          {isAdmin && <NavSection title="Settings" items={navItems.settings} showIcons={true} />}
          <NavSection title="Switch System" items={navItems.switchSystem} showIcons={true} />
        </ul>
      </nav>
    </aside>
  );
}
